module.exports = __webpack_public_path__ + "img/thumbnail_Coyote_f_normal.7d688ef6.png";